import styled from 'styled-components'
import { commonTextStyledProps, SharedStyle } from '@components/base/Text'

export const TextInput = styled.input<SharedStyle>`
    ${({ theme, ...rest }) => commonTextStyledProps(theme, rest)}
    padding: 5px;
    text-overflow: ellipsis;
    text-wrap: normal;
    max-height: 500px;
    overflow-y: auto;
    color: black;
    outline: 0;
    border: 0;
    ${({ fullWidth }) => fullWidth && `flex: 1;`}
`

export const TextAreaInput = styled.textarea<SharedStyle>`
    ${({ theme, ...rest }) => commonTextStyledProps(theme, rest)}
    padding: 5px;
    text-overflow: ellipsis;
    text-wrap: normal;
    max-height: 500px;
    overflow-y: auto;
    color: black;
    resize: vertical;
    outline: 0;
    border: 0;
    ${({ fullWidth }) => fullWidth && `flex: 1;`}
`
